import type { StyleTemplateWithUrls } from 'schemas';
import type { EntityCardProps } from '@/components/EntityCard';
import { sharedMessages } from '@/shared-messages/shared.messages';

export const transformStyleTemplateToEntityCard = (
  styleTemplate: StyleTemplateWithUrls
): EntityCardProps => {
  return {
    title: styleTemplate.title,
    description: styleTemplate.description,
    imageUrls: styleTemplate.imageUrls,
    imageAlt: `Style template: ${styleTemplate.title}`,
    actions: [
      {
        actionButtonLabel: sharedMessages.commonButtons.edit,
        onButtonClick: () => {
          // TODO: Implement edit functionality
          console.log('Edit style template:', styleTemplate.id);
        },
      },
      {
        actionButtonLabel: sharedMessages.commonButtons.delete,
        onButtonClick: () => {
          // TODO: Implement delete functionality
          console.log('Delete style template:', styleTemplate.id);
        },
      },
    ],
  };
};
